import { usePaymentConfirmationStore } from '../../Stores/paymentConfirmationStore'
import { useCancelDigitalSignatureProcessStore } from '../../Stores/useCancelDigitalSignatureProcessStore'
import { useRefreshDigitalSignatureStatusStore } from '../../Stores/useRefreshDigitalSignatureStatusStore'
import { useRefreshFirstReceiptStatusStore } from '../../Stores/useRefreshFirstReceiptStatusStore'
import { useSubmitProposalStore } from '../../Stores/useSubmitProposalStore'
import { DIGITAL_STATUS } from '../../constants/digitalStatus'
import { INVOICE_STATUS } from '../../constants/invoiceStatus'
import { t } from '../../i18n'

export const useStatusMessages = () => {
  const { isSignatureDigital, isFirstReceiptPaid } =
    usePaymentConfirmationStore()
  const { refreshDigitalSignatureStatus } =
    useRefreshDigitalSignatureStatusStore()
  const { cancelDigitalSignatureProcess } =
    useCancelDigitalSignatureProcessStore()
  const { submitProposal } = useSubmitProposalStore()
  const { refreshFirstReceiptStatus } = useRefreshFirstReceiptStatusStore()

  const invoiceStatusOffer =
    (refreshFirstReceiptStatus?.invoiceStatus ||
      cancelDigitalSignatureProcess?.firstReceiptInfo?.status ||
      refreshDigitalSignatureStatus?.firstReceiptInfo?.status ||
      submitProposal?.firstReceiptInfo?.status) === INVOICE_STATUS.OFFER

  const policyStateMessage = () => {
    let message = ''
    const signatureStatus =
      refreshDigitalSignatureStatus?.digitalSignature?.status

    if (signatureStatus !== DIGITAL_STATUS.SIG) {
      if (isSignatureDigital) {
        message = t('pages.step7.signatureMessageStatus.pendingDigital')
      } else if (cancelDigitalSignatureProcess?.policySubStatusDescription) {
        message = cancelDigitalSignatureProcess?.policySubStatusDescription
      } else {
        message = t('pages.step7.signatureMessageStatus.pending')
      }
    }

    if (signatureStatus === DIGITAL_STATUS.SIG) {
      message = t('pages.step7.signatureMessageStatus.payment')
    }

    return message
  }

  const receiptStatusMessage = () => {
    let message = ''

    if (invoiceStatusOffer && !isFirstReceiptPaid) {
      message = t('pages.step7.receiptMessageStatus.offer')
    } else if (isFirstReceiptPaid) {
      message = t('pages.step7.receiptMessageStatus.charged')
    } else {
      message = t('pages.step7.receiptMessageStatus.inDebit')
    }

    return message
  }

  return {
    policyStateMessage,
    receiptStatusMessage,
  }
}
